module.exports = __webpack_public_path__ + "img/ouzo.6816df03.jpg";